"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("../client/useRouter.js");exports.default=function(){return e.default()};
